import React from 'react';
import { ICampaignDetails } from '../../../interfaces/campaign.interface';
import { useAppDispatch } from '../../../store/store';
import { SetSelectedCampaign } from '../../../store/slice/campaign.slice';
import { Button } from 'react-bootstrap';

interface IProps {
    campaign: ICampaignDetails;
    setIsSwitching: React.Dispatch<React.SetStateAction<boolean>>;
}

const SwitchCampaignPlan = ({ campaign, setIsSwitching }: IProps) => {
    const dispatch = useAppDispatch();

    const handlePlanSelect = () => {
        dispatch(SetSelectedCampaign(campaign));
        setIsSwitching(false);
    };

    return (
        <div className="tw-w-[328px] tw-p-4 tw-border tw-rounded-lg">
            <div className="tw-font-semibold tw-text-purple-100">{campaign.name}</div>
            <div className="tw-my-4">
                <div className="tw-flex tw-flex-col tw-items-start tw-justify-between tw-h-[102px]">
                    <div>
                        <div className="tw-text-purple-100 tw-font-semibold">Objectives</div>
                        <div className="tw-w-[296px] tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap tw-text-sm">
                            {campaign.objective}
                        </div>
                    </div>
                    <div>
                        <div className="tw-text-purple-100 tw-font-semibold">Target Audience</div>
                        <div className="tw-w-[296px] tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap tw-text-sm">
                            {campaign.target_audience}
                        </div>
                    </div>
                </div>
            </div>
            <Button
                className="tw-bg-purple-50 tw-text-black tw-w-full tw-border-none"
                onClick={handlePlanSelect}
            >
                Select Plan
            </Button>
        </div>
    );
};

export default SwitchCampaignPlan;
